import React from 'react';
import { PlusIcon } from '@heroicons/react/16/solid';

/**
 * The quiet outline button of a record page's header strip — the create
 * buttons there, and the page's own labelled actions beside them ("View
 * as homeowner"), so the strip reads as one row.
 */
export const headerButtonClass =
  'inline-flex shrink-0 items-center gap-1 rounded-md border border-line px-2 py-1 text-[12px] font-medium text-fg-secondary hover:bg-fg/5 hover:text-fg focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-1 disabled:opacity-50 disabled:hover:bg-transparent';

/**
 * A list's create button (#632): one size, one colour, one place — the
 * filter bar's trailing slot, next to the view switch — on violations,
 * work orders and communications alike.
 *
 * `secondary` is the quieter outline a record page's header strip uses
 * (`CreateActions`), where several sit side by side; below `sm` it keeps
 * only the icon, and the label moves to the accessible name.
 */
export const CreateButton: React.FC<{
  label: string;
  onClick: () => void;
  variant?: 'primary' | 'secondary';
}> = ({ label, onClick, variant = 'primary' }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={variant === 'secondary' ? label : undefined}
    title={variant === 'secondary' ? label : undefined}
    className={
      variant === 'primary'
        ? 'inline-flex shrink-0 items-center gap-1 rounded-md bg-accent px-2 py-1 text-[12px] font-medium text-white hover:bg-accent/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-1'
        : headerButtonClass
    }
  >
    <PlusIcon className="h-3.5 w-3.5" aria-hidden />
    {variant === 'primary' ? (
      label
    ) : (
      <span className="hidden sm:inline" aria-hidden>
        {label}
      </span>
    )}
  </button>
);
